<form class="flex justify-between flex-col h-full" [formGroup]="form" (ngSubmit)="submit()">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Create an Account</h1>
    <p class="text-base opacity-80 mt-2">Please enter your email and name to continue</p>

    <div class="grid grid-cols-12 gap-4 mt-5">
      <div class="col-span-12 form-group">
        <label for="email">Email Address</label>
        <input
          id="email"
          placeholder="youremail@email.com"
          type="email"
          autocapitalize="off"
          autocomplete="off"
          formControlName="email"
        />
        <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched" class="text-red-600 text-sm mt-1">
          <span *ngIf="form.get('email')?.errors?.['required']">Email is required.</span>
          <span *ngIf="form.get('email')?.errors?.['email']">Please enter a valid email address.</span>
        </div>
      </div>

      <div class="col-span-12 md:col-span-6 form-group">
        <label for="first-name">First Name</label>
        <input
          id="first-name"
          placeholder="Enter First Name"
          type="text"
          autocapitalize="off"
          autocomplete="off"
          minlength="3"
          formControlName="firstName"
        />
        <div *ngIf="form.get('firstName')?.invalid && form.get('firstName')?.touched" class="text-red-600 text-sm mt-1">
          <span *ngIf="form.get('firstName')?.errors?.['required']">First Name is required.</span>
          <span *ngIf="form.get('firstName')?.errors?.['minlength']">The first name must have at least 3 characters</span>
        </div>
      </div>


      <div class="col-span-12 md:col-span-6 form-group">
        <label for="last-name">Last Name</label>
        <input
          id="last-name"
          placeholder="Enter Last Name"
          type="text"
          autocapitalize="off"
          autocomplete="off"
          minlength="3"
          formControlName="lastName"
        />
        <div *ngIf="form.get('lastName')?.invalid && form.get('lastName')?.touched" class="text-red-600 text-sm mt-1">
          <span *ngIf="form.get('lastName')?.errors?.['required']">Last Name is required.</span>
          <span *ngIf="form.get('lastName')?.errors?.['minlength']">The last name must have at least 3 characters</span>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full">
    <!-- <div class="my-4">
      <label class="inline-flex items-center gap-2">
        <input type="checkbox" [checked]="isIncubator()" (change)="onIncubatorToggle($event)" />
        <span>I’m an Incubator</span>
      </label>
    </div> -->

    <app-button (click)="submit()" class="font-bold" [disabled]="form.invalid || loading" type="submit">
      {{ loading ? 'Submitting...' : 'Continue' }}
    </app-button>

    <div class="text-center mt-4">
      <span class="opacity-65 font-semibold mr-3">Already have an account?</span>
      <a [routerLink]="'/auth/login'" class="text-ladder-purpleMedium underline font-bold">Log in</a>
    </div>
  </div>
</form>
